module.exports = __webpack_public_path__ + "static/media/trash_new.821f7850.svg";